import { render, staticRenderFns } from "./NotificationSkeletonLoader.vue?vue&type=template&id=11e62a62&scoped=true&"
import script from "./NotificationSkeletonLoader.vue?vue&type=script&lang=ts&"
export * from "./NotificationSkeletonLoader.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationSkeletonLoader.vue?vue&type=style&index=0&id=11e62a62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e62a62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VDivider,VRow,VSkeletonLoader})
